/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Article_Created_SuccessInputs */

const en_toast_article_created_success = /** @type {(inputs: Toast_Article_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article created successfully`)
};

const nl_toast_article_created_success = /** @type {(inputs: Toast_Article_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel succesvol aangemaakt`)
};

/**
* | output |
* | --- |
* | "Article created successfully" |
*
* @param {Toast_Article_Created_SuccessInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_article_created_success = /** @type {((inputs?: Toast_Article_Created_SuccessInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Article_Created_SuccessInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_article_created_success(inputs)
	return en_toast_article_created_success(inputs)
});